import {Component, inject} from '@angular/core';

import {SvgSpriteIcon} from '@selpia/shared/ui';
import {AppNotificationsService} from '../app-notifications.service';

@Component({
  selector: 'lib-feature-notifications',
  standalone: true,
  templateUrl: './feature-notifications.component.html',
  styleUrl: './feature-notifications.component.scss',
  host: {
  '(click)':'handleClick($event);',
  }
})
export class FeatureNotificationsComponent {
  readonly #notificationService: AppNotificationsService = inject(AppNotificationsService);

  SvgSpriteIcon = SvgSpriteIcon;

  protected readonly isActive = this.#notificationService.isActive;

  handleClick(event: MouseEvent): void {
    event.stopPropagation();
    this.#notificationService.toggleSubscription();
  }
}
